<template>
  <div class="c_social_share">
    <Button
      class="c_social_share__button"
      @onClick="clickHandler"
      unstyle
      reset
      :aria-expanded="!canShare ? (ariaExpanded ? 'true' : 'false') : false"
      ><slot>Share</slot></Button
    >
    <slot v-if="showFallback" name="fallback"></slot>
  </div>
</template>

<script>
import { log, error } from 'JS/global.js';
import Button from 'Components/button/Button.vue';
export default {
  components: {
    Button,
  },
  data() {
    return {
      ariaExpanded: false,
      canShare: false,
      showFallback: false,
    };
  },
  props: {
    shareTitle: { type: String, required: true },
    shareText: { type: String, required: true },
    shareUrl: { type: String, required: true },
  },
  computed: {},
  methods: {
    clickHandler() {
      if (this.ariaExpanded) {
        this.ariaExpanded = false;
      } else {
        this.ariaExpanded = true;
      }

      if (this.canShare) {
        this.shareUrlHandler();
      } else {
        this.triggerFallback();
      }
    },
    shareUrlHandler() {
      if (this.canShare) {
        const shareInfo = { url: this.shareUrl };
        if (this.shareTitle) {
          shareInfo.title = this.shareTitle;
        }
        if (this.shareText) {
          shareInfo.text = this.shareText;
        }
        navigator
          .share(shareInfo)
          .then(() => {
            this.$emit('shareSuccess');
            log('Thanks for sharing!');
          })
          .catch((err) => {
            this.$emit('shareError', err.message);
            error(`Couldn't share because of`, err.message);
          });
      }
    },
    triggerFallback() {
      if (this.showFallback) {
        this.showFallback = false;
      } else {
        this.showFallback = true;
      }
    },
  },
  created() {
    if (process.client) {
      if (navigator.share) {
        this.canShare = true;
      }
    }
  },
  mounted() {},
};
</script>

<style lang="scss">
.c_social_share {
  $self: &;
}
</style>
